// @flow
import React, {PureComponent} from "react";
import {Polyline} from "react-google-maps";
import {connect} from "react-redux";
import {getCurvedPolylinePath, getLatLngFromLatLngLiteral,} from "../../../Utils/MapUtils";
import CurrentRequestSelectors from "../../../Store/Ducks/CurrentRequest/selectors";
import CurrentRideSelectors from "../../../Store/Ducks/CurrentRide/selectors";
import type {RideStatusType} from "../../../Utils/AppUtils";
import {RideStatus} from "../../../Utils/AppUtils";


type ConnectedProps = {|
    originLat: number,
    originLng: number,
    pickupLat: number,
    pickupLng: number,
    rideStatus: RideStatusType,
|};

class RideWalkingMap extends PureComponent<ConnectedProps> {

    render() {
        if (!(this.props.originLat && this.props.originLng &&
            this.props.pickupLat && this.props.pickupLng &&
            this.props.rideStatus < RideStatus.ACCEPTED)) {
            return null;
        }
        let walkingPath = getCurvedPolylinePath(
            getLatLngFromLatLngLiteral({lat: this.props.originLat, lng: this.props.originLng}),
            getLatLngFromLatLngLiteral({lat: this.props.pickupLat, lng: this.props.pickupLng}));
        return (<Polyline
            path={walkingPath}
            options={{
                geodesic: true,
                strokeOpacity: 1,
                strokeColor: "grey"
            }}
        />);
    }
}

const mapStateToProps = (state, props) => {
    return {
        originLat: CurrentRequestSelectors.getOriginLat(state),
        originLng: CurrentRequestSelectors.getOriginLng(state),
        pickupLat: CurrentRideSelectors.getPickupLat(state),
        pickupLng: CurrentRideSelectors.getPickupLng(state),
        pickupLocation: CurrentRideSelectors.getPickup(state),
        rideStatus: CurrentRideSelectors.getRideStatus(state),
    };
};
export default connect(mapStateToProps)(RideWalkingMap);



// WEBPACK FOOTER //
// ./src/Components/Map/WalkingMap/ProposalWalkingMap.js